/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSystemSettingViewModel } from '../../models/client-system-setting-view-model';

export interface GetClientSystemSettings$Params {
  clientID: number;
      body?: {
'systemFeatureID'?: number;
'systemSettingID'?: number;
}
}

export function GetClientSystemSettings(http: HttpClient, rootUrl: string, params: GetClientSystemSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSystemSettingViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetClientSystemSettings.PATH, 'post');
  if (params) {
    rb.path('clientID', params.clientID, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSystemSettingViewModel>>;
    })
  );
}

GetClientSystemSettings.PATH = '/api/Clients/GetClientSystemSettings/{clientID}';
